var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-icon"},[_vm._v("\n  STEP "+_vm._s(_vm.step)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }